import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { LatLngBoundsLiteral } from "leaflet";

import { MAP_CENTER } from "Constants/App";
import type { IPoint } from "Types/point";

interface IState {
  center: IPoint;
  zoom: number;
  mouse?: IPoint;
  minimize?: boolean;
  view: { center: IPoint; zoom: number } | null;
  bounds: { positions: LatLngBoundsLiteral; options?: {} } | null;
  moveEnd: boolean;
  // moveStart: boolean;
  contextPosition: any;
  contextPosition2: any;
  showContext: boolean;
  showContext2: boolean;
  closeContext: boolean;
  showPin: boolean;
  selectLocMode: 0 | 1 | 2 | 3;
  selectedLoc: [{ lat: number; lng: number }, { lat: number; lng: number }];
  showAddSurvayModal: boolean;
  selectLocFor: "add-station" | "add-survay" | "";
  showAddStationModal: boolean;
  stationLoc: { lat: number; lng: number };
  storedStation: any;
  updateShowStationMarker: boolean;
  largeIconByClick: number;
}
interface IActionPayload {
  center?: IPoint;
  zoom?: number;

  mouse?: IPoint;
  minimize?: boolean;
  view?: { center: IPoint; zoom: number } | null;
  bounds?: { positions: LatLngBoundsLiteral; options?: {} } | null;
}

const initialState: IState = {
  center: MAP_CENTER,
  zoom: 12,
  view: null,
  bounds: null,
  minimize: false,
  moveEnd: false,
  // moveStart: false,
  contextPosition: { lat: 10, lng: 10 },
  contextPosition2: { lat: 10, lng: 10 },
  showContext: false,
  showContext2: false,
  closeContext: false,
  showPin: false,
  selectLocMode: 0,
  selectedLoc: [
    { lat: 0, lng: 0 },
    { lat: 0, lng: 0 },
  ],
  stationLoc: { lat: 0, lng: 0 },
  showAddSurvayModal: false,
  showAddStationModal: false,
  selectLocFor: "",
  storedStation: {},
  updateShowStationMarker: false,
  largeIconByClick: 0,
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setMapData: (state, action: PayloadAction<IActionPayload>) => {
      return { ...state, ...action.payload };
    },
    setMinimize: (state, action: PayloadAction<boolean>) => {
      return { ...state, minimize: action.payload };
    },
    toggleMoveEnd: (state) => {
      return { ...state, moveEnd: !state.moveEnd };
    },
    changeShowContext: (state, action: PayloadAction<boolean>) => {
      return { ...state, showContext: action.payload };
    },
    changeShowContext2: (state, action: PayloadAction<boolean>) => {
      return { ...state, showContext2: action.payload };
    },
    changeCloseContext: (state, action: PayloadAction<boolean>) => {
      return { ...state, closeContext: action.payload };
    },
    changeContextPosition: (state, action: PayloadAction<any>) => {
      return { ...state, contextPosition: action.payload };
    },
    changeContextPosition2: (state, action: PayloadAction<any>) => {
      return { ...state, contextPosition2: action.payload };
    },
    changeShowPin: (state, action: PayloadAction<boolean>) => {
      return { ...state, showPin: action.payload };
    },
    changeShowAddSurvayModal: (state, action: PayloadAction<boolean>) => {
      return { ...state, showAddSurvayModal: action.payload };
    },
    changeSelectLocMode: (state, action: PayloadAction<0 | 1 | 2 | 3>) => {
      return { ...state, selectLocMode: action.payload };
    },
    setSelectedLoc: (state, action: PayloadAction<any>) => {
      return { ...state, selectedLoc: action.payload };
    },
    setStationLoc: (state, action: PayloadAction<any>) => {
      return { ...state, stationLoc: action.payload };
    },
    changeSelectLocFor: (state, action: PayloadAction<"add-station" | "add-survay" | "">) => {
      return { ...state, selectLocFor: action.payload };
    },
    changeShowAddStationModal: (state, action: PayloadAction<boolean>) => {
      return { ...state, showAddStationModal: action.payload };
    },
    changeStoredStation: (state, action: PayloadAction<any>) => {
      return { ...state, storedStation: action.payload };
    },
    toggleShowStationMarker: (state) => {
      return { ...state, updateShowStationMarker: !state.updateShowStationMarker };
    },
    changeLargeIconByClick: (state, action: PayloadAction<any>) => {
      return { ...state, largeIconByClick: action.payload };
    },
  },
});

export const {
  setMapData,
  setMinimize,
  toggleMoveEnd,
  changeShowContext,
  changeCloseContext,
  changeShowContext2,
  changeContextPosition,
  changeContextPosition2,
  changeShowPin,
  changeSelectLocMode,
  setSelectedLoc,
  changeShowAddSurvayModal,
  changeSelectLocFor,
  changeShowAddStationModal,
  setStationLoc,
  changeStoredStation,
  toggleShowStationMarker,
  changeLargeIconByClick,
} = mapSlice.actions;

export default mapSlice.reducer;
